import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuardarMultiProyectoComponent } from '../../components/guardar-multi-proyecto/guardar-multi-proyecto.component';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		GuardarMultiProyectoComponent
	],
	templateUrl: './guardar-multi-proyecto.view.html',
	styleUrls: ['./guardar-multi-proyecto.view.scss']
})
export class GuardarMultiProyectoView {}
